// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1rAsa","title":"ClientReferral_title__1MMbo","itemText":"ClientReferral_itemText__1Gh3G"};